import React from 'react';
import { useLocation } from 'react-router-dom';
import {
    useSsDispatch as useDispatch,
    useSsSelector as useSelector,
} from '~SpectateStore';
import { useUpdateEffect } from '~shared/hooks/useUpdateEffect';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import {
    changeHeaderTab,
    setFullScreenOff,
} from '~Betslip/slices/uiSlice';

import {
    selectIsBetslipTab,
    selectIsMyBetsTab,
    selectIsFullScreen,
    selectOpenBetsCount,
    selectIsBettingEnabled,
} from '~Betslip/selectors/uiSelectors';

import {
    selectCountUserSelections,
} from '~Betslip/selectors/userSelectionsSelectors';

import {
    selectShowBetReceipt,
} from '~Betslip/selectors/betReceiptSelectors';

import {
    goBackToBetslip,
} from '~Betslip/slices/betReceiptSlice';

import './styles.scss';
import { setSiteScrollDisabled } from '~spa/Utils/WrapperIntegration/Ucf';

const HeaderTabs = () => {
    const [ t ] = useTranslation();
    const dispatch = useDispatch();
    const isFullScreen = useSelector(selectIsFullScreen);
    const isBetslipTab = useSelector(selectIsBetslipTab);
    const isMyBetsTab = useSelector(selectIsMyBetsTab);
    const count = useSelector(selectCountUserSelections);
    const openBetsCount = useSelector(selectOpenBetsCount);
    const isReceiptShown = useSelector(selectShowBetReceipt);
    const isBettingEnabled = useSelector(selectIsBettingEnabled);
    const { pathname: currentUrlPath } = useLocation();

    const isOpenBetsDisabled = currentUrlPath === '/bets' || currentUrlPath.startsWith('/bets/');

    useUpdateEffect(() => {
        if (isOpenBetsDisabled) {
            dispatch(changeHeaderTab('betslip'));
            if (isFullScreen) {
                exitFullScreenBetslip();
            }
        }
    }, [isOpenBetsDisabled]);

    const switchHeaderTab = (tab) => {
        if (isReceiptShown) {
            dispatch(goBackToBetslip());
        }
        dispatch(changeHeaderTab(tab));
    };

    const exitFullScreenBetslip = () => {
        dispatch(setFullScreenOff());
        setSiteScrollDisabled(false);
    };

    const showCloseOption = () => {
        if (!isFullScreen) {
            return null;
        }

        return (
            <li
                className="fullslip__headerTab fullslip__headerTab--exitFullScreen"
                onClick={exitFullScreenBetslip}
            >x</li>
        );
    };

    const renderBetslipTab = () => {
        const tabClasses = classNames(
            'fullslip__headerTab',
            isBetslipTab && 'fullslip__headerTab--active',
            !isBettingEnabled && 'betslip--disabled',
        );

        const counterClasses = classNames(
            'fullslip__headerTabCounter',
            isBetslipTab && 'fullslip__headerTabCounter--active',
        );

        if (!isBettingEnabled) {
            switchHeaderTab('my-bets');
        }

        return (
            <li
                className={tabClasses}
                data-spectate-product="new-betslip;tabs;betslip"
                onClick={() => switchHeaderTab('betslip')}
            >
                <span className={counterClasses}>{count}</span>
                {t('betslip.betslip')}
            </li>
        );
    };

    const renderMyBetsTab = () => {
        const tabClasses = classNames(
            'fullslip__headerTab',
            isMyBetsTab && 'fullslip__headerTab--active',
            isOpenBetsDisabled && 'fullslip__headerTab--disabled',
        );

        const counterClasses = classNames(
            'fullslip__headerTabCounter',
            isMyBetsTab && 'fullslip__headerTabCounter--active',
        );

        return (
            <li
                className={tabClasses}
                data-spectate-product="new-betslip;tabs;my-bets"
                onClick={() => {
                    if (!isOpenBetsDisabled) {
                        switchHeaderTab('my-bets');
                    }
                }}
            >
                <span className={counterClasses} data-test-id="betslip;tabs-counter">
                    {openBetsCount}
                </span>
                {t('betslip.my_bets')}
            </li>
        );
    };

    return (
        <ul className="fullslip__headerTabs">
            {renderBetslipTab()}
            {renderMyBetsTab()}
            {showCloseOption()}
        </ul>
    );
};

export default HeaderTabs;
